<template>
  <div class="layout" :class="{ grow: grow }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    grow: Boolean
  }
}
</script>

<style scoped>
.layout { flex-shrink: 0; height: 100%; }
.layout:not(:first-child) { /* border-left: 1px solid rgba(140, 158, 255, .07); */ }
.grow { flex: 1 1; }
</style>



// WEBPACK FOOTER //
// src/components/layouts/MLayout.vue